<template>
    <el-dialog title="Allocation" :visible.sync="thisvisible">
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="allocationForm"
                    :model="thisallocation"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 700px;"
                >
                    <el-form-item
                        label="Année"
                        prop="annee"
                        :error="getErrorForField('annee', errors)"
                    >
                        <el-date-picker
                            value-format="yyyy"
                            type="year"
                            v-model="thisallocation.annee"
                        />
                        / {{ parseInt(thisallocation.annee) + 1 }}
                    </el-form-item>
                    <el-form-item
                        label="Millésime"
                        prop="millesime"
                        :error="getErrorForField('millesime', errors)"
                    >
                        <el-date-picker
                            value-format="yyyy"
                            type="year"
                            v-model="thisallocation.millesime"
                        />
                    </el-form-item>
                    <el-form-item
                        label="Fermeture"
                        prop="fin_allocation"
                        :error="getErrorForField('fin_allocation', errors)"
                    >
                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            format="dd/MM/yyyy"
                            type="date"
                            v-model="thisallocation.fin_allocation"
                        />
                    </el-form-item>
                    <el-form-item label="État" prop="etat">
                        <el-select
                            v-model="thisallocation.etat"
                            placeholder="Select"
                        >
                            <el-option
                                v-for="etat in etats"
                                :key="etat.value"
                                :label="etat.label"
                                :value="etat.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        label="Max"
                        prop="max"
                        :error="getErrorForField('max', errors)"
                    >
                        <el-input v-model="thisallocation.max" />
                    </el-form-item>
                    <el-form-item
                        label="Maxo Magnum"
                        prop="maxmagnum"
                        :error="getErrorForField('maxmagnum', errors)"
                    >
                        <el-input v-model="thisallocation.maxmagnum" />
                    </el-form-item>
                    <el-form-item
                        label="Description"
                        prop="description"
                        :error="getErrorForField('description', errors)"
                    >
                        <el-input
                            type="textarea"
                            :rows="5"
                            v-model="thisallocation.description"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button type="primary" @click="save">
                            Enregistrer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
const allocationResource = new Resource("allocations");

export default {
    name: "Allocation",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        allocation: {
            type: Object,
            default: () => {
                return {
                    annee: "2020",
                    millesime: "2020",
                    description: "",
                    etat: "attente",
                    fin_allocation: "",
                    max: 12,
                    maxmagnum: 3
                };
            }
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {
                annee: {},
                millesime: {},
                fin_allocation: {},
                max: {},
                maxmagnum: {},
                description: {}
            },
            errors: [],
            thisallocation: {
                annee: "2020",
                millesime: "2020",
                description: "",
                etat: "attente",
                fin_allocation: "",
                max: 12,
                maxmagnum: 3
            },
            etats: [
                { value: "encours", label: "En cours" },
                { value: "finalisee", label: "Finalisée" },
                { value: "attente", label: "En attente" }
            ]
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.allocation) {
                    Object.assign(this.thisallocation, this.allocation);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogAllocationVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {},
    methods: {
        save() {
            this.errors = [];
            this.loading = true;
            if (this.thisallocation.id) {
                allocationResource
                    .update(this.thisallocation.id, this.thisallocation)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.parent.callbackAllocation(false, response.data);
                        this.thisvisible = false;
                        this.$message({
                            message: "Allocation mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                allocationResource
                    .store(this.thisallocation)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Allocation créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackAllocation(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
